import { useTranslation } from 'react-i18next';
import { AnimatedSection } from '../../../components/AnimatedSection';

export default function Mission() {
  const { t } = useTranslation();

  const items = [
    { icon: 'ri-focus-3-line', title: t('about_mission_i1_title'), desc: t('about_mission_i1_desc') },
    { icon: 'ri-eye-line', title: t('about_mission_i2_title'), desc: t('about_mission_i2_desc') },
    { icon: 'ri-links-line', title: t('about_mission_i3_title'), desc: t('about_mission_i3_desc') },
  ];

  return (
    <section className="py-20 bg-slate-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <AnimatedSection animation="slide-right">
            <span className="text-cyan-400 text-sm font-semibold tracking-widest uppercase">{t('about_mission_badge')}</span>
            <h2 className="text-4xl font-bold text-white mt-3 mb-5 leading-tight">
              {t('about_mission_title1')}<br />
              <span className="text-cyan-400">{t('about_mission_title2')}</span>
            </h2>
            <p className="text-slate-400 leading-relaxed mb-5">
              {t('about_mission_desc1')}
            </p>
            <p className="text-slate-400 leading-relaxed mb-8">
              {t('about_mission_desc2')}
            </p>
            <div className="space-y-4">
              {items.map(item => (
                <div key={item.title} className="flex gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-cyan-500/10 rounded-lg shrink-0">
                    <i className={`${item.icon} text-cyan-400`}></i>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold text-sm">{item.title}</h4>
                    <p className="text-slate-400 text-xs mt-0.5">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </AnimatedSection>

          <AnimatedSection animation="slide-left">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/595000a328806c762212e5f6220d0d7d.jpg"
                alt="A&B System Technical Team"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute bottom-6 left-6 right-6 bg-slate-900/90 backdrop-blur-sm border border-slate-700 rounded-xl p-5">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-3xl font-bold text-cyan-400">99.9%</div>
                    <div className="text-sm text-slate-400 mt-0.5">{t('about_mission_uptime_label')}</div>
                  </div>
                  <div className="w-14 h-14 flex items-center justify-center bg-cyan-500/10 rounded-full">
                    <i className="ri-server-line text-cyan-400 text-2xl"></i>
                  </div>
                </div>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}
